import { CustomQuestionOptionMapper } from 'mapper/CustomQuestionOptionMapper';

export const customQuestionOptionMapper = new CustomQuestionOptionMapper();
